<p-dialog
  [visible]="visible()"
  (visibleChange)="visible.set($event)"
  [modal]="true"
  [dismissableMask]="false"
  [closeOnEscape]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '780px', maxWidth: '95vw' }"
  styleClass="document-asset-wizard-dialog"
  [header]="dialogTitle()"
  role="dialog"
  aria-modal="true"
  [attr.aria-label]="dialogTitle()"
>
  <ol class="wizard-steps" aria-label="Fasi del wizard">
    <li
      *ngFor="let label of stepLabels(); let i = index"
      class="wizard-steps__item"
      [class.is-current]="step() === i + 1"
      [class.is-done]="step() > i + 1"
      [attr.aria-current]="step() === i + 1 ? 'step' : null"
    >
      <span class="wizard-steps__badge">{{ i + 1 }}</span>
      <span class="wizard-steps__label">{{ label }}</span>
    </li>
  </ol>

  <!-- STEP: Upload (create only) -->
  <section *ngIf="isUploadStep()" class="wizard-step" aria-labelledby="wizard-step1-title">
    <h3 id="wizard-step1-title" class="wizard-step__title">Carica il file</h3>
    <p class="wizard-step__intro">
      Trascina o seleziona il file da registrare. Verrà analizzato prima della
      pubblicazione.
    </p>

    <app-file-drop-zone
      [name]="'document-asset-upload'"
      [accept]="acceptedMime()"
      [maxFileSize]="20 * 1024 * 1024"
      [multiple]="false"
      [label]="'File da caricare'"
      [helpText]="'Dimensione massima 20&nbsp;MB'"
      (filesSelected)="onFilesSelected($event)"
      (fileRemoved)="onFileRemoved()"
      (filesCleared)="onFileRemoved()"
    ></app-file-drop-zone>
  </section>

  <!-- STEP: Metadata (+ optional new file in edit) -->
  <section *ngIf="isMetadataStep()" class="wizard-step" aria-labelledby="wizard-step2-title">
    <h3 id="wizard-step2-title" class="wizard-step__title">Metadati e attivazione</h3>
    <p class="wizard-step__intro">
      Compila le informazioni necessarie a identificare e pubblicare il documento.
    </p>

    <div *ngIf="isEdit()" class="wizard-form__row">
      <p class="wizard-form__help">
        <strong>Sostituzione file (opzionale):</strong>
        trascina un nuovo file per creare una nuova versione, oppure lascia vuoto per mantenere quello corrente.
      </p>
      <app-file-drop-zone
        [name]="'document-asset-upload-edit'"
        [accept]="acceptedMime()"
        [maxFileSize]="20 * 1024 * 1024"
        [multiple]="false"
        [label]="'Nuovo file (opzionale)'"
        [helpText]="'Dimensione massima 20&nbsp;MB'"
        (filesSelected)="onFilesSelected($event)"
        (fileRemoved)="onFileRemoved()"
        (filesCleared)="onFileRemoved()"
      ></app-file-drop-zone>
    </div>

    <form [formGroup]="form" class="wizard-form" (ngSubmit)="runAnalyze()">
      <div class="wizard-form__row">
        <label class="wizard-form__field" for="wizard-name">
          <span class="wizard-form__label">Nome <span aria-hidden="true">*</span></span>
          <input
            pInputText
            id="wizard-name"
            formControlName="name"
            maxlength="200"
            required
            aria-required="true"
            [attr.aria-invalid]="form.get('name')?.invalid && form.get('name')?.touched ? 'true' : null"
          />
          <small
            *ngIf="form.get('name')?.invalid && form.get('name')?.touched"
            class="wizard-form__error"
            role="alert"
          >
            Il nome è obbligatorio (max 200 caratteri).
          </small>
        </label>
      </div>

      <div class="wizard-form__row">
        <label class="wizard-form__field" for="wizard-businessKey">
          <span class="wizard-form__label">
            Business key <span aria-hidden="true">*</span>
            <button
              *ngIf="!isEdit()"
              type="button"
              pButton
              class="p-button-text p-button-sm wizard-form__override-btn"
              (click)="toggleBusinessKeyOverride()"
              [attr.aria-pressed]="showBusinessKeyOverride()"
            >
              {{ showBusinessKeyOverride() ? 'Auto-genera' : 'Modifica manualmente' }}
            </button>
          </span>
          <input
            pInputText
            id="wizard-businessKey"
            formControlName="businessKey"
            required
            aria-required="true"
            aria-describedby="wizard-businessKey-help"
          />
          <small id="wizard-businessKey-help" class="wizard-form__help">
            <ng-container *ngIf="!isEdit()">
              Chiave stabile per correlare le versioni. Generata dal nome; modificabile solo prima della registrazione.
            </ng-container>
            <ng-container *ngIf="isEdit()">
              La business key non è modificabile: identifica l'asset e le sue versioni.
            </ng-container>
          </small>
          <small
            *ngIf="form.get('businessKey')?.invalid && form.get('businessKey')?.touched"
            class="wizard-form__error"
            role="alert"
          >
            Ammessi solo caratteri A-Z, 0-9 e underscore.
          </small>
        </label>
      </div>

      <div class="wizard-form__row wizard-form__row--split">
        <label class="wizard-form__field" for="wizard-subDomain">
          <span class="wizard-form__label">Categoria documento <span aria-hidden="true">*</span></span>
          <p-select
            inputId="wizard-subDomain"
            formControlName="subDomainType"
            [options]="subDomainOptions"
            optionLabel="label"
            optionValue="value"
            [showClear]="true"
            placeholder="Seleziona una categoria"
            appendTo="body"
          ></p-select>
          <small
            *ngIf="form.get('subDomainType')?.invalid && form.get('subDomainType')?.touched"
            class="wizard-form__error"
            role="alert"
          >
            Seleziona una categoria documento.
          </small>
        </label>

        <label class="wizard-form__field" for="wizard-activation">
          <span class="wizard-form__label">Modalità di attivazione <span aria-hidden="true">*</span></span>
          <p-select
            inputId="wizard-activation"
            formControlName="activationMode"
            [options]="activationOptions"
            optionLabel="label"
            optionValue="value"
            appendTo="body"
          ></p-select>
        </label>
      </div>

      <div
        class="wizard-form__row wizard-form__row--split"
        *ngIf="form.get('activationMode')?.value === 'REGISTER_AND_SCHEDULE'"
      >
        <label class="wizard-form__field" for="wizard-validFrom">
          <span class="wizard-form__label">Valido dal</span>
          <p-datepicker
            inputId="wizard-validFrom"
            formControlName="validFrom"
            dateFormat="dd/mm/yy"
            appendTo="body"
            [minDate]="minScheduleDate"
            [showIcon]="true"
          ></p-datepicker>
          <small
            *ngIf="form.get('validFrom')?.hasError('pastDate')"
            class="wizard-form__error"
          >
            La data non può essere nel passato.
          </small>
        </label>
        <label class="wizard-form__field" for="wizard-validTo">
          <span class="wizard-form__label">Valido fino al</span>
          <p-datepicker
            inputId="wizard-validTo"
            formControlName="validTo"
            dateFormat="dd/mm/yy"
            appendTo="body"
            [minDate]="form.get('validFrom')?.value || minScheduleDate"
            [showIcon]="true"
          ></p-datepicker>
          <small
            *ngIf="form.get('validTo')?.hasError('pastDate')"
            class="wizard-form__error"
          >
            La data non può essere nel passato.
          </small>
        </label>
      </div>

      <div class="wizard-form__row">
        <label class="wizard-form__field" for="wizard-changeDesc">
          <span class="wizard-form__label">Descrizione della modifica</span>
          <textarea
            pTextarea
            id="wizard-changeDesc"
            formControlName="changeDescription"
            rows="3"
            maxlength="2000"
            aria-describedby="wizard-changeDesc-help"
          ></textarea>
          <small id="wizard-changeDesc-help" class="wizard-form__help">
            Nota tracciata a fini di compliance (max 2000 caratteri).
          </small>
        </label>
      </div>
    </form>
  </section>

  <!-- STEP: Review & confirm -->
  <section *ngIf="isReviewStep()" class="wizard-step" aria-labelledby="wizard-step3-title">
    <h3 id="wizard-step3-title" class="wizard-step__title">Verifica e conferma</h3>

    <ng-container *ngIf="analysis() as report">
      <div
        *ngIf="hasBlockingErrors()"
        class="wizard-analysis__block wizard-analysis__block--danger"
        role="alert"
      >
        <p class="wizard-analysis__title">
          <i class="pi pi-times-circle" aria-hidden="true"></i>
          Errori bloccanti
        </p>
        <p class="wizard-analysis__hint">
          Il documento non può essere registrato finché gli errori seguenti non vengono risolti.
        </p>
        <ul class="wizard-analysis__list">
          <li *ngFor="let err of report.blockingErrors">{{ err }}</li>
        </ul>
      </div>

      <div
        *ngIf="!hasBlockingErrors()"
        class="wizard-analysis__block wizard-analysis__block--success"
        role="status"
        aria-live="polite"
      >
        <p class="wizard-analysis__title">
          <i class="pi pi-check-circle" aria-hidden="true"></i>
          Analisi completata senza errori
        </p>
        <p class="wizard-analysis__hint">
          Il documento è pronto per essere registrato. Rivedi i dettagli qui sotto e conferma.
        </p>
      </div>

      <div
        *ngIf="report.warnings.length"
        class="wizard-analysis__block wizard-analysis__block--warn"
        role="status"
      >
        <p class="wizard-analysis__title">Avvertimenti</p>
        <ul class="wizard-analysis__list">
          <li *ngFor="let warn of report.warnings">{{ warn }}</li>
        </ul>
      </div>

      <div class="wizard-analysis__block" *ngIf="report.detectedVariables.length">
        <p class="wizard-analysis__title">Variabili rilevate</p>
        <div class="wizard-analysis__chips">
          <p-tag
            *ngFor="let v of report.detectedVariables"
            [value]="v"
            severity="info"
          ></p-tag>
        </div>
      </div>

      <div class="wizard-analysis__block" *ngIf="report.suggestedBindings.length">
        <p class="wizard-analysis__title">Binding suggeriti</p>
        <ul class="wizard-analysis__list">
          <li *ngFor="let b of report.suggestedBindings">
            <strong>{{ b.assetBusinessKey }}</strong>
            <span class="wizard-analysis__muted">({{ b.assetType }}<span *ngIf="b.bindingRole"> · {{ b.bindingRole }}</span>)</span>
          </li>
        </ul>
      </div>
    </ng-container>

    <p *ngIf="!analysis()" class="wizard-analysis__muted">
      Nessun risultato di analisi disponibile.
    </p>
  </section>

  <ng-template pTemplate="footer">
    <div class="wizard-footer">
      <p-button
        *ngIf="step() > 1"
        label="Indietro"
        icon="pi pi-arrow-left"
        severity="secondary"
        [variant]="'outlined'"
        (onClick)="isReviewStep() ? backToMetadata() : backToUpload()"
        [disabled]="isAnalyzing() || isSubmitting()"
        ariaLabel="Torna allo step precedente"
      ></p-button>

      <p-button
        label="Annulla"
        severity="secondary"
        [variant]="'outlined'"
        (onClick)="visible.set(false)"
        [disabled]="isSubmitting()"
        ariaLabel="Annulla e chiudi"
      ></p-button>

      <p-button
        *ngIf="isUploadStep()"
        label="Continua"
        icon="pi pi-arrow-right"
        iconPos="right"
        (onClick)="goToMetadata()"
        [disabled]="!selectedFile()"
      ></p-button>

      <p-button
        *ngIf="isMetadataStep()"
        [label]="isAnalyzing() ? 'Analisi in corso…' : 'Analizza e continua'"
        icon="pi pi-search"
        [loading]="isAnalyzing()"
        (onClick)="runAnalyze()"
        [disabled]="formInvalid()"
      ></p-button>

      <p-button
        *ngIf="isReviewStep()"
        [label]="isEdit() && !requiresNewVersion() ? 'Salva modifiche' : 'Registra'"
        icon="pi pi-check"
        [loading]="isSubmitting()"
        (onClick)="register()"
        [disabled]="hasBlockingErrors() || !analysis()"
      ></p-button>
    </div>
  </ng-template>
</p-dialog>
